import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative overflow-hidden" data-id="element-133">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-bold text-brown mb-8" data-id="element-135">
          The Investment In Yourself
        </h2>

        <p className="text-lg md:text-xl text-brown-light font-body mb-12 leading-relaxed" data-id="element-136">
          If you hired a maternity coach, a nutritionist, and a psychologist,
          you'd pay over $1,000. But my mission is that no mother feels alone or
          lost in this process. That's why today, you won't pay{' '}
          <span className="line-through decoration-coral decoration-2" data-id="element-137">
            $197
          </span>
          .
        </p>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-warm-lg border border-gold/20 relative" data-id="element-138">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-gold text-white px-6 py-2 rounded-full font-bold text-sm tracking-wider uppercase shadow-md whitespace-nowrap" data-id="element-139">
            Special Market Test Price
          </div>

          <h3 className="font-heading text-2xl text-brown mb-4" data-id="element-140">
            GET THE ENTIRE SYSTEM TODAY FOR ONLY:
          </h3>

          <div className="flex flex-col items-center gap-2 mb-8" data-id="element-141">
            <span className="text-7xl md:text-8xl font-bold font-heading text-coral" data-id="element-142">
              $6.39
            </span>
            <span className="inline-block bg-sage/10 text-sage font-bold text-lg px-4 py-1.5 rounded-full" data-id="element-143">
              You save 97% off the $197 value
            </span>
          </div>

          <CTAButton className="w-full sm:w-auto text-xl py-5 px-10 mb-6" data-id="element-144">
            YES, I WANT INSTANT ACCESS
          </CTAButton>

          <div className="flex items-center justify-center gap-2 text-sm text-brown-light font-body" data-id="element-145">
            <ShieldCheck className="w-5 h-5 text-sage" data-id="element-146" />
            <span data-id="element-147">Secure, encrypted checkout. Instant digital delivery.</span>
          </div>
        </div>

        <p className="mt-8 text-coral-dark font-medium italic text-sm md:text-base" data-id="element-148">
          (This special price is part of a market test and will increase at any
          moment without notice).
        </p>
      </div>
    </section>;
}